import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagedResult } from 'app/models/order';
import { Observable } from 'rxjs';

export interface BannerTypeData{
  type?: string;
  value?: string;
  lang?: string;
  banners?: BannerItem[];
  
}
export interface BannerItem {
  id: number;
  title?: string;
  type?: string;
  photo?: string;
  link?: string;
  url?: string;
  isActive?: boolean;
  sortOrder?: number;
}

export interface BannerResponseDto {
  success?: boolean;
  message?: string;
  data?: BannerItem[];
}


@Injectable({
  providedIn: 'root'
})
export class BannerService {
   private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api/v2" ;
  }

  constructor(private http: HttpClient) {}

  private getHeaders(language: string = 'en'): HttpHeaders {
    return new HttpHeaders({
      'Language': language
    });
  }

  getBanner(num:number ,language: string = 'en'): Observable<BannerResponseDto> {
    return this.http.get<BannerResponseDto>(`${this.apiUrl}/banner/${num}`, {
      headers: this.getHeaders(language)
    });
  }
  getBanners(pageNumber: number = 1, pageSize: number = 10): Observable<PagedResult<BannerTypeData>> {
    return this.http.get<PagedResult<BannerTypeData>>(`${this.apiUrl}/banners?pageNumber=${pageNumber}&pageSize=${pageSize}`);
  }
  getTypes(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/types`);
  }

  getHomeSlider(language: string = 'en'): Observable<BannerResponseDto> {
    return this.http.get<BannerResponseDto>(`${this.apiUrl}/home-slider`, {
      headers: this.getHeaders(language)
    });
  }

  getSliders(language: string = 'en'): Observable<BannerResponseDto> {
    return this.http.get<BannerResponseDto>(`${this.apiUrl}/sliders`, {
      headers: this.getHeaders(language)
    });
  }

  getAll(bannerNumber: number, language: string = 'en'): Observable<BannerItem[]> {
    return this.http.get<BannerItem[]>(`${this.apiUrl}/banner/${bannerNumber}`, {
      headers: this.getHeaders(language)
    });
  }

  createBanner(payload: CreateBannerDto): Observable<any> {
  const body = {
    title: payload.title,
    type: payload.type,
    link: payload.link,
    imageFile: payload.imageFile,
    sortOrder: payload.sortOrder,
    isActive: payload.isActive
  };

  return this.http.post(`${this.apiUrl}/BannerOrSlider`, body);
}

updateBanner(id: number, payload: UpdateBannerDto): Observable<any> {
  const body = {
    title: payload.title,
    type: payload.type,
    link: payload.link,
    imageFile: payload.imageFile,
    sortOrder: payload.sortOrder,
    isActive: payload.isActive
  };

  return this.http.put(`${this.apiUrl}/BannerOrSlider/${id}`, body);
}

  deleteBanner(banner: string, id: number, language: string = 'en'): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${banner}/items/${id}/${language}`, {
      headers: this.getHeaders(language)
    });
  }
}

export interface CreateBannerDto {
  title?: string;
  type?: string;
  link?: string;
  languageCode?: string; // default = 'en'
  imageFile?: string[];
  sortOrder?: number;
  isActive?: boolean;
}

export interface UpdateBannerDto {
  title?: string;
  description?: string;
  type?: string;
  link?: string;
  imageFile?: string [];
  sortOrder?: number;
  isActive?: boolean;
}